import styled, { css } from "styled-components";
import { skeletonAnimation } from "./Animations.ts";

const AvatarBase = css`
    border-radius: var(--border-radius);
    image-orientation: from-image;
    aspect-ratio: 1 / 1;
    min-width: 50px;
    //height: 75px;
    //width: 75px;
    object-fit: cover;
`;

export const AvatarIMG = styled.img`
    ${AvatarBase};
    image-orientation: from-image;
`;

export const AvatarContainer = styled.div`
    position: absolute;
    background-color: var(--background);
    padding: 12px;
    padding-bottom: 0;
    border-top-left-radius: var(--border-radius);
    border-top-right-radius: var(--border-radius);
    bottom: 0;
    left: max(5%, var(--spacing-18));
    width: 30%;
    max-width: 150px;
`;

export const AvatarSkeleton = styled.div`
    ${AvatarBase};
    ${skeletonAnimation};
`;

const BackgroundBase = css`
    border-top-left-radius: var(--border-radius);
    border-top-right-radius: var(--border-radius);
    aspect-ratio: 3 / 1;
    max-height: 200px;
    width: 100%;
    min-height: 125px;
    object-fit: cover;
`;

export const BackgroundIMG = styled.img`
    ${BackgroundBase};
    image-orientation: from-image;
`;

export const BackgroundSkeleton = styled.div`
    ${BackgroundBase};
    height: auto;
    width: 100%;
    ${skeletonAnimation};
`;

export const HeaderContainer = styled.div`
    position: relative;
    align-items: center;
    justify-content: center;
    width: 100%;
`;

export const AvatarError = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    aspect-ratio: 1 / 1;
    min-height: 50px;
    min-width: 50px;
    border-radius: var(--border-radius);
    background-color: var(--danger);
`;
